import {ActionHandler} from "../../../../../infrastructure/handlers/action-handler";
import {CURRENT_ODDS_MODULE} from "../current-odds-module.consts";

export class CurrentOddsModuleToggleOddsMenuHandler extends ActionHandler {
  type = CURRENT_ODDS_MODULE.ACTION_TYPES.toggleOddsMenu;


  async action(params) {
    this.store.toggleCurrentOddsDropdownVisible();
  }
}
